// lib/daimon/modules.ts
/** The modules the Daimon can open for the user, and the left-bar button her cursor clicks for each. */
export const DAIMON_MODULE_BUTTONS = {
  source: 'portal-nav-source',
  studio_canvas: 'portal-nav-studio-canvas',
  studio_list: 'portal-nav-studio-list',
  studio_vector: 'portal-nav-studio-vector',
  analyst: 'portal-nav-tables',
  slides: 'portal-nav-slides',
  finance: 'portal-nav-finance',
  brands: 'portal-nav-brand-base',
  plan: 'portal-nav-footfall',
  fater3d: 'portal-nav-fater3d',
  home: null,
} as const;

export type DaimonModule = keyof typeof DAIMON_MODULE_BUTTONS;

/**
 * A module's conversation (ChatSession.creationModule) -> the agent mode whose actions she runs there.
 * A new tool whose conversations carry its own mode needs no line here: an unknown creationModule is
 * taken as its mode (DaimonVoice modeOf), so its actions are hers the day they ship.
 */
export const DAIMON_MODE_BY_MODULE: Readonly<Record<string, string>> = { studio: 'director', source: 'commander', global: 'commander', slides: 'slides', analyst: 'commander', pulse: 'pulse' };
/** Conversations that are not a tool's: hers, the orchestrator's, the doctrine steward's. */
export const NOT_A_TOOL_MODULE: ReadonlySet<string> = new Set(['daimon', 'master', 'doctrine']);
export const DAIMON_MODULES = Object.keys(DAIMON_MODULE_BUTTONS) as DaimonModule[];
